import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { WarehouseUpdateInput } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { WAREHOUSES_QUERY_KEY } from './useWarehouses';
import { WAREHOUSE_QUERY_KEY } from './useWarehouse';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useUpdateWarehouse = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['warehouse', 'update'],
    mutationFn: async (input: WarehouseUpdateInput) => {
      return await warehouseService.updateWarehouse(input);
    },
    onSuccess: (data) => {
      toast.success(tActionMessages.warehouseUpdatedSuccessfully);
      queryClient.invalidateQueries({ queryKey: WAREHOUSES_QUERY_KEY });
      queryClient.invalidateQueries({
        queryKey: [...WAREHOUSE_QUERY_KEY, data.warehouseId],
      });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, 'Failed to update warehouse'));
    },
  });
};

export default useUpdateWarehouse;
